import { ReactNode } from 'react';
import { UiIcon } from 'znanie-uikit';
import css from './SeatsLeftContainer.module.scss';

interface IProps {
  children: ReactNode;
}

export default function SeatsLeftContainer({ children }: IProps) {
  return (
    <div className={css.container}>
      <div className={css.icon}>
        <UiIcon name="person" size={8} />
      </div>
      {children}
    </div>
  );
}
